import { colors, css, fonts } from ".";

/* eslint-disable */
enum Colors {
    blackPrimary = "#1D1D1B",
    greyDarkPrimary = "#293032",
    greyDarkSecondary = "#3B4143",
    greyPrimary = "#757D80",
    greySecondary = "#697073",
    // greyTertiary = "#C8C8C9",
    greyTertiary = "#BCBCBC",
    greyLightPrimary = "#CCCCCC",
    greyLightSecondary = "#D9D9D9",
    greyLightTertiary = "#E8E8E8",
    whitePrimary = "#FFFFFF",
    transparent = "#FFFFFF00",

    blueDarkPrimary = "#4563AC",
    blueDarkSecondary = "#3D5AA3",
    blueLightPrimary = "#A4B9CF",
    blueLightSecondary = "#93AECB",

    systemRed = "#772634",
    systemYellow = "#CCC27D",
    systemGreen = "#67A86B",

    graphWater = "#2E7CBD",
    graphTemperature = "#B21920",
    graphGrowth = "#F9C953",
    graphActivity = "#E5560F",
    graphAverage= "#00933D",
    graphBlueOne = "#91AFD3",
    graphBlueTwo = "#1C2D41",
    graphBlueThree = "#7EA1BB",
    graphBlueFour = "#3B506F",
    graphBlueFive = "#A8BAD3",
    graphBlueSix = "#E6EEFF",
    graphBlueSeven = "#728AA9",
    graphBlueEight = "#5B7691",
    graphBlueNine = "#D3E4F7",
    graphBlueTen = "#4D6786",
    graphBlueEleven = "#2E4259",
    graphBlueTwelve = "#C6D6EB",

    piggyPink = "#BB8CA4"
}

type GraphColorResult = {
  graphColor: string;
  textColor: string;
};
/* eslint-enable */

export const getGraphColor = (id: number): GraphColorResult => {
  if (Number.isNaN(id)) {
    return { graphColor: "transparent", textColor: colors.whitePrimary };
  }

  if (id === -1) {
    return { graphColor: colors.greyPrimary, textColor: colors.whitePrimary };
  }

  if (id === 1) {
    return { graphColor: colors.graphWater, textColor: colors.whitePrimary };
  }

  const graphColors: {color: Colors, backgroundColor: Colors}[] = [
    {color: colors.whitePrimary, backgroundColor: Colors.graphBlueOne},
    {color: colors.whitePrimary, backgroundColor: Colors.graphBlueTwo},
    {color: colors.whitePrimary, backgroundColor: Colors.graphBlueThree},
    {color: colors.whitePrimary, backgroundColor: Colors.graphBlueFour},
    {color: colors.whitePrimary, backgroundColor: Colors.graphBlueFive},
    {color: colors.greyDarkSecondary, backgroundColor: Colors.graphBlueSix},
    {color: colors.whitePrimary, backgroundColor: Colors.graphBlueSeven},
    {color: colors.whitePrimary, backgroundColor: Colors.graphBlueEight},
    {color: colors.greyDarkSecondary, backgroundColor: Colors.graphBlueNine},
    {color: colors.whitePrimary, backgroundColor: Colors.graphBlueTen},
    {color: colors.whitePrimary, backgroundColor: Colors.graphBlueEleven},
    {color: colors.greyDarkSecondary, backgroundColor: Colors.graphBlueTwelve},
  ];

  const index = Math.abs(id) % graphColors.length;

  return {
    graphColor: graphColors[index].backgroundColor,
    textColor: graphColors[index].color,
  }
}

export { Colors as colors}